import ConfirmationModalLauncher from "./ConfirmationModalLauncher";

export default ConfirmationModalLauncher;
